export enum WINNER {
  a = "a",
  b = "b",
  c = "c",
}

export type SimpleParticipant = {
  title: string;
  icon: string | null;
};

export type Participant = {
  id: number;
  scoreText: string;
} & SimpleParticipant;

export type Game = {
  scoreType: string;
  date: string;
  contentDescription: string;
  gameTitleWithScoreText?: string;
  gameScore?: string | null;
  firstParticipant?: SimpleParticipant;
  secondParticipant?: SimpleParticipant;
  participants?: Participant[];
  winner?: WINNER;
  isLive?: boolean;
};
